import { render } from "./UserWorkReportsSection.vue?vue&type=template&id=69c80cc6&scoped=true&ts=true&lang=pug"
import script from "./UserWorkReportsSection.vue?vue&type=script&lang=ts"
export * from "./UserWorkReportsSection.vue?vue&type=script&lang=ts"

import "./UserWorkReportsSection.vue?vue&type=style&index=0&id=69c80cc6&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c80cc6"]])

export default __exports__